import { render, staticRenderFns } from "./FormElementExampleSentence.vue?vue&type=template&id=3e83abe4&scoped=true&"
import script from "./FormElementExampleSentence.vue?vue&type=script&lang=js&"
export * from "./FormElementExampleSentence.vue?vue&type=script&lang=js&"
import style0 from "./FormElementExampleSentence.vue?vue&type=style&index=0&id=3e83abe4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e83abe4",
  null
  
)

export default component.exports